/* RunsOnAtlassianBadge.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _26 = "._w1ap1osq._w1ap1osq{width:100%}";
const _25 = "._1kba1h6o._1kba1h6o{align-items:center}";
const _24 = "._if291txw._if291txw{display:flex}";
const _23 = "._kkk2n7od{all:unset}";
const _22 = "._1wyboqnp{font-size:.75rem}";
const _21 = "._k48pni7l{font-weight:600}";
const _20 = "._1ccqt94y{word-spacing:1px}";
const _19 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _18 = "._18u0v77o{margin-left:var(--ds-space-025,2px)}";
const _17 = "._18u0u2gc{margin-left:var(--ds-space-100,8px)}";
const _16 = "._4cvr1h6o{align-items:center}";
const _15 = "._2lx2vrvc{flex-direction:row}";
const _14 = "._18u0idpf{margin-left:0}";
const _13 = "._otyridpf{margin-bottom:0}";
const _12 = "._2hwxidpf{margin-right:0}";
const _11 = "._19pkidpf{margin-top:0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EVENT_CONTAINER_RUNS_ON_ATLASSIAN_TOOLTIP, LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { BodySmall, DatabaseIcon, LinkWithIcon, LocationPinIcon, LockIcon, RunsOnAtlassianIcon } from '@atlassian/mpac-primitives';
import { ExternalLinks } from '@atlassian/mpac-types';
import queryString from 'query-string';
import RichTooltip from '../../primitives/RichTooltip';
import { TEST_IDS } from '../../primitives/testIds';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _10 = "._2mzuglyw{list-style-type:none}";
const _9 = "._1p57u2gc{row-gap:var(--ds-space-100,8px)}";
const _8 = "._2lx21bp4{flex-direction:column}";
const _7 = "._1e0c1txw{display:flex}";
const _6 = "._otyrutpp{margin-bottom:var(--ds-space-150,9pt)}";
const _5 = "._p12f1tad{max-width:21.25rem}";
const _4 = "._19bvidpf{padding-left:0}";
const _3 = "._n3tdidpf{padding-bottom:0}";
const _2 = "._u5f3idpf{padding-right:0}";
const _ = "._ca0qidpf{padding-top:0}";
const ANALYTICS_SUBJECT_ID_VIEW_MORE_LINK = 'viewMoreLink';
const DetailsContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "ul",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8, _9, _10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _p12f1tad _otyrutpp _1e0c1txw _2lx21bp4 _1p57u2gc _2mzuglyw", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  DetailsContainer.displayName = 'DetailsContainer';
}
const DetailsRow = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "li",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11, _12, _13, _14, _7, _15, _16]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  DetailsRow.displayName = 'DetailsRow';
}
const DetailsText = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _18u0u2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  DetailsText.displayName = 'DetailsText';
}
const BadgeLabel = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_18, _19, _20, _21, _22]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18u0v77o _syaz1gjq _1ccqt94y _k48pni7l _1wyboqnp", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BadgeLabel.displayName = 'BadgeLabel';
}
const BadgeContainer = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_23, _24, _25, _26]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_kkk2n7od _if291txw _1kba1h6o _w1ap1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BadgeContainer.displayName = 'BadgeContainer';
}
const TooltipContent = _ref6 => {
  let {
    link
  } = _ref6;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const onViewDetailsClick = e => {
    fireAnalyticsEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_VIEW_MORE_LINK,
      eventContainer: EVENT_CONTAINER_RUNS_ON_ATLASSIAN_TOOLTIP,
      attributes: {
        label: e.target.text
      }
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(DetailsContainer, {
      "data-testid": TEST_IDS.RUNS_ON_ATLASSIAN_TOOLTIP,
      children: [/*#__PURE__*/_jsxs(DetailsRow, {
        children: [/*#__PURE__*/_jsx(DatabaseIcon, {}), /*#__PURE__*/_jsx(DetailsText, {
          children: "Hosted on Atlassian"
        })]
      }), /*#__PURE__*/_jsxs(DetailsRow, {
        children: [/*#__PURE__*/_jsx(LockIcon, {}), /*#__PURE__*/_jsx(DetailsText, {
          children: "Data stored within Atlassian"
        })]
      }), /*#__PURE__*/_jsxs(DetailsRow, {
        children: [/*#__PURE__*/_jsx(LocationPinIcon, {}), /*#__PURE__*/_jsx(DetailsText, {
          children: "Data residency compliant"
        })]
      })]
    }), /*#__PURE__*/_jsx(LinkWithIcon, {
      type: "external",
      size: "small",
      href: link,
      onClick: onViewDetailsClick,
      children: "More details"
    })]
  });
};
export const RunsOnAtlassianBadge = () => {
  const onBadgeContainerClick = e => e.stopPropagation();
  const faqPageLink = queryString.stringifyUrl({
    url: ExternalLinks.cloudFortified.faq,
    query: {
      source: 'app-listing-badge'
    }
  });
  return /*#__PURE__*/_jsx(RichTooltip, {
    content: /*#__PURE__*/_jsx(TooltipContent, {
      link: faqPageLink
    }),
    children: /*#__PURE__*/_jsxs(BadgeContainer, {
      tabIndex: -1,
      onClick: onBadgeContainerClick,
      children: [/*#__PURE__*/_jsx(RunsOnAtlassianIcon, {
        label: "Runs on atlassian badge"
      }), /*#__PURE__*/_jsx(BadgeLabel, {
        children: "RUNS ON ATLASSIAN"
      })]
    })
  });
};